import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, InputAdornment, TextField, Autocomplete, ListItem, ListItemText } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid';
import * as yup from 'yup';
import { useFormik } from 'formik';
const DialogArtigo = ({ stock, initial, onClose, ...props }) => {
    const [art, setArtigo] = useState();
    const validationSchema = yup.object({
        produtoId: yup.number(),
        quantidadeEfetiva: yup
            .number()
            .min(0, 'O valor não pode ser menor que 0')
            .max(art ? art.quantidade : 0, 'O valor ultrapassa a quantidade em stock existente')
            .required('O campo é obrigatório'),
        quantidadeFaturada: yup.number().min(0, 'O valor não pode ser menor que 0').required('O campo é obrigatório'),
        pvp: yup.number()
    });
    const formik = useFormik({
        initialValues: initial,
        validationSchema: validationSchema,
        validateOnMount: false,
        onSubmit: async (values) => {
            onClose(values);
        }
    });
    // Formik fix dialog reuse
    useEffect(() => {
        formik.resetForm();
        formik.setValues(initial ?? {});
    }, [initial]);
    return (<Dialog {...props}>
      <form>
        <DialogTitle>Artigo</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={4} md={4} xs={12}>
              <Autocomplete id={`produtoId`} options={stock} getOptionLabel={list => list.Produto.primaveraId} onChange={(event, value) => {
            formik.setFieldValue(`produtoId`, value.produtoId);
            formik.setFieldValue('pvp', value.Produto.valor);
            setArtigo(value);
        }} 
    //includeInputInList
    renderOption={(props, option) => (<ListItem key={option.id} {...props}>
                    <ListItemText primary={option.Produto.primaveraId}></ListItemText>
                  </ListItem>)} renderInput={params => (<TextField {...params} fullWidth onBlur={formik.handleBlur} error={formik.touched?.produtoId && Boolean(formik.errors?.produtoId)} helperText={formik.touched?.produtoId && formik.errors?.produtoId} label='Cód. Artigo *' name={`produtoId`}/>)}/>
            </Grid>
            <Grid lg={8} md={8} xs={12}>
              <TextField disabled label='Designação' InputLabelProps={{
            shrink: art ? true : false
        }} value={art?.Produto?.designacao} fullWidth/>
            </Grid>
            <Grid lg={6} md={6} xs={6}>
              <TextField label='Quantidade efetiva*' type='number' name='quantidadeEfetiva' InputProps={{
            endAdornment: art ? <InputAdornment position='end'>Máx: {art.quantidade}</InputAdornment> : undefined
        }} value={formik.values?.quantidadeEfetiva} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.quantidadeEfetiva && Boolean(formik.errors.quantidadeEfetiva)} helperText={formik.touched.quantidadeEfetiva && formik.errors.quantidadeEfetiva}/>
            </Grid>
            <Grid lg={6} md={6} xs={6}>
              <TextField label='Quantidade faturada*' type='number' name='quantidadeFaturada' value={formik.values?.quantidadeFaturada} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.quantidadeFaturada && Boolean(formik.errors.quantidadeFaturada)} helperText={formik.touched.quantidadeFaturada && formik.errors.quantidadeFaturada}/>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type='button' onClick={() => onClose(undefined)}>
            Cancelar
          </Button>
          <Button onClick={() => {
            formik.handleSubmit();
        }} disabled={!formik.isValid || !formik.dirty || formik.isSubmitting} variant='contained'>
            OK
          </Button>
        </DialogActions>
      </form>
    </Dialog>);
};
export default DialogArtigo;
